import { Component, AfterViewInit, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { ModalpopService } from '../modalpop.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
@Component({
  selector: 'app-additional-details',
  templateUrl: './additional-details.component.html',
  styleUrls: ['./additional-details.component.scss']
})
export class AdditionalDetailsComponent implements OnInit, AfterViewInit {
  @Input() tabName: string = '';
  @Output() next = new EventEmitter<void>();
  // @Output() prev = new EventEmitter<void>();
  @Output() prev = new EventEmitter<boolean>();
  @Output() first = new EventEmitter<void>();
  dialogRef: MatDialogRef<any>;
  maxdate: any;
  minDate: any;
  maxdate2: any;
  minDate2: any;
  disabled = false;
  tabs : string;
  displayName : any;
  Course: any;
  College: any;
  EmpTypeCodeList: any;
  filteredListEmpTypeCode: any;
  districtList: any[];
  filteredListdistrictCode: any[];
  collegedataList: any;
  filteredListCollege: any;
  MediumCodeList: any;
  filteredListMediumCode: any;
  SnNo: any;
  contactDetails: any;
  StuNationality: any;
  CourseLevel: any;

  constructor(private fb: FormBuilder, public umsService: UmsService, public datepipe: DatePipe,
    private modalPopupService: ModalpopService, private router: Router,
    private spinner: NgxSpinnerService) { }

  additionalDetailsForm: FormGroup;
  submitButton = true;
  updateButton = false;
  AdharPhone = false;
  AadharCard = false;
  AbcId = false
  otherCourse=false;
  additionalDetailsFormArray;
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId'); 
  session = sessionStorage.getItem('session');

  calledApi = 0; // Total number of APIs called
  finishedApi = 0; // Total number of APIs completed (success or failure)
 
  ngOnInit(): void {

    this.maxdate = new Date();
    this.minDate = new Date(2010, 0, 1);
    this.disabled = false;
    this.maxdate2 = new Date();
    this.minDate2 = new Date(2010, 0, 1);
    this.submitButton = true;
    this.updateButton = false;
    this.AdharPhone = false;
    this.AadharCard = false;
    this.AbcId = false
    this.session = sessionStorage.getItem('session');
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.spinner.show();
    // this.getScrutiny();
    this.fetchContact();   
    this.getSecretData();
    this.getApplyData();
    this.fetchEmpType();   
    this.fetchMedium();    
    this.getDistrictData(); 
    this.prepopulation();
    this.additionalDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuExtraId: new FormControl(),
      WorkExperience: new FormControl('N')
    });
  }
  ngAfterViewInit(): void {
    // this.prepopulation();
    // this.fetchEmpType();   
    // this.fetchMedium();    
    // this.getDistrictData();
    this.fetchContact(); 
    if(this.StuNationality == 'OS') {
      this.additionalDetailsForm.controls['StuABCId2'].setValue('');
      this.additionalDetailsForm.controls['StuABCId2'].clearValidators();
    }
    else { this.additionalDetailsForm.controls['StuABCId2'].setValidators([Validators.required, Validators.minLength(12), Validators.maxLength(12)]); }
      this.additionalDetailsForm.controls['StuABCId2'].updateValueAndValidity();
      this.AdharPhone = false;
      this.additionalDetailsForm.controls['StuAadharPhone'].setValue('');
      this.additionalDetailsForm.controls['StuAadharPhone'].clearValidators();
      this.additionalDetailsForm.controls['StuAadharPhone'].updateValueAndValidity(); 
  }

  getSecretData() {
    this.calledApi++;
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.SnNo = res.projectPharam['SnNo'];
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
      }
      else{
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
      }
    },(ERROR:HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      };
    });
  }
    
  getFeeStatus(StuId) {
    const payload = {};
    payload['StuId'] = StuId;
    payload['SnNo'] = this.session;
    this.umsService.getFeeStatus(payload).subscribe(res => {
      if (res.status) {
        console.log('fees status response i get is', res.data);
        this.getScrutiny(StuId)
      }
      else {
        this.disabled = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.disabled = false;
    })
  }

  getScrutiny(StuId) {
    this.calledApi++; // Increment the called API count
    const payload = {};
    payload['StudentId'] = StuId
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      if(res.status){
        this.tabs = res.data[0].Tabs;
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
          if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
          if(res.data[0].Tabs.includes('Additional Details')){
            this.disabled = false;
          }else{
            this.disabled = true;
          }
        }
        else {
          this.disabled = true;
        }
      }
      else{
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  fetchDate(item) {
     if (item[0].StuFromDate == "1970-01-01" && item[0].StuToDate == "1970-01-01") {
      item[0].StuFromDate = '';
      item[0].StuToDate = ''
    }
  }

  prepopulation() {
    // this.spinner.show();
    this.calledApi++; // Increment the called API count
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.fetchContact();
    this.umsService.fetchAdditionalDetails(payload).subscribe(async (res) => {
      console.log("res status in additional details: ",res.status);
      if (res.status) {
        if(res.data[0].StuABCId == 2){
          this.AdharPhone = true;
          this.AbcId = false
        }
        else if(res.data[0].StuABCId == 1){
          this.AdharPhone = false;
          this.AbcId = true
        }

        if(res.data[0].StuAadhar == 1){
          this.AadharCard = true
        }
        else if(res.data[0].StuAadhar == 2){
          this.AadharCard = false
        }
        this.spinner.hide();
        await this.fetchDate(res.data)
        await this.fetchEmpType();   
        await  this.fetchMedium();   
        await  this.getDistrictData();   
        await this.getCollegeData(res.data[0].StuDistrictAd)
        await this.getFeeStatus(res.data[0].StuId)
        if (res.data.length > 0) {

          // this.umsService.disable5 = false;
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          this.submitButton = false;
          this.updateButton = true;
           this.additionalDetailsForm.get('WorkExperience')?.setValue(
    res.data[0].FieldValue
  );
          await this.prepopulatedatapage(res); 
        } else {
          await this.loadsettingspage();  
        }
      } else {
         await this.loadsettingspage();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }


  prepopulation2() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchAdditionalDetails(payload).subscribe((res) => {
      if (res.status) {
         this.spinner.hide();
        if (res.data.length > 0) {
          this.umsService.disable5 = false;
              } else {
           this.umsService.disable5 = true;
        }
      } else {
        this.spinner.hide();
        this.loadsettingspage();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  prepopulatedatapage(e) {
    this.spinner.show()
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.additionalDetailsForm.controls['StuExtraId'].setValue(e.data[0]['StuExtraId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide()
      ress.data.forEach((element) => {
        if(element.FormControlName == 'StuAadharPhone') {
          element.FormRequired = false;
          element.FormVisible = false;
        }
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));

            } else {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));

            }
          } else {
            if (element.FormPattern == '') {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
            }
            else {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.pattern(element.FormPattern)]));
            }
          }
        } else {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.additionalDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      // this.additionalDetailsForm.controls['StuABCId'].setValue(1);
      //  this.AdharContact(1)
       this.reassignValidator()
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  loadsettingspage() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';

    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if(element.FormControlName == 'StuABCId') {
          element.FormVisible = false;
          element.FormRequired = false;
        }
        if(element.FormControlName == 'StuABCId2') {
          element.FormVisible = true;
          element.FormRequired = true;
        }
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            } else {
              this.additionalDetailsForm.addControl(
                element.FormControlName,
                new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)])
              );
            }

          } else {
            if (element.FormPattern == '') {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(''));
            } else {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.pattern(element.FormPattern)]));
            }
          }
        }
      });
      this.additionalDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      // this.additionalDetailsForm.controls['StuABCId'].setValue(1);
      // this.AdharContact(1)
    this.reassignValidator()
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  SubmitFormarkAsTouched() {
    this.spinner.show() 
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide()
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            const control = this.additionalDetailsForm.get(element.FormControlName);
            if (control) {
              control.markAsTouched();
              console.log("control",control)
              // this.additionalDetailsForm.get('StuABCId2').markAsTouched();
            }
          }
        }
      });
      this.additionalDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  submitAdditionalDetails() {
    if (this.additionalDetailsForm.invalid) {
      // this.SubmitFormarkAsTouched();
      Object.keys(this.additionalDetailsForm.controls).forEach(key =>{
         const control = this.additionalDetailsForm.get(key);
         if(control.invalid){
          console.log(`Validation error in ${key} control`,control);
         }
      })
      this.additionalDetailsForm.markAllAsTouched();
    }
    else {
      this.spinner.show();
      let payload = this.additionalDetailsForm.value;
       payload.StuOrgDonate = parseInt(payload.StuOrgDonate);
      payload.StuHostelAccod = parseInt(payload.StuHostelAccod);
      payload.StuFmlyInc = parseInt(payload.StuFmlyInc);
      payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
      let da = this.additionalDetailsForm.value.StuFromDate;
      payload['StuFromDate'] = this.datepipe.transform(da, 'yyyy-MM-dd');
      let da1 = this.additionalDetailsForm.value.StuToDate;
      payload['StuToDate'] = this.datepipe.transform(da1, 'yyyy-MM-dd');
       this.umsService.addAdditionalDetails(payload).subscribe(res => {
        if(res.status){
          this.saveWorkExperience();
          this.spinner.hide();
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
          this.next.emit();
        }
        else{
          this.spinner.hide();
        }
         }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);

      });
    }

  }
  // getTabName(e){
  //   this.displayName = e;
  // }
  getTabDisplayName(): string {
    return `Current Tab: ${this.tabName}`;
  }
  UpdScrtDetails(){
    this.spinner.show();
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CgCode'] = this.College
    payload['CoCode'] = this.Course
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if(res.status){
        this.first.emit();
        location.reload();
        this.spinner.hide();
      }
      else{
        this.spinner.hide();
        
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
  getApplyData(){
     this.calledApi++; // Increment the called API count
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if(res.status){
       this.Course = res.data[0]['Course'];
       this.College = res.data[0]['College'];
       this.CourseLevel = res.data[0]['CourseLevel'];
       this.finishedApi++; // Increment the finished API count
       if (this.finishedApi === this.calledApi) {
         this.spinner.hide();
       }
      }
      else{
        this.finishedApi++; // Increment the finished API count
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }
  updateAdditionalDetails() {
    // this.AdharContact(this.additionalDetailsForm.controls['StuABCId'].value);
      console.log('this.additionalDetailsForm',this.additionalDetailsForm)
    if (this.additionalDetailsForm.invalid) {
        //  this.SubmitFormarkAsTouched();
        Object.keys(this.additionalDetailsForm.controls).forEach(key =>{
         const control = this.additionalDetailsForm.get(key);
         if(control.invalid){
          console.log(`Validation error in ${key} control`,control);
         }
      })
      this.additionalDetailsForm.markAllAsTouched();
    }
          this.Update();

  }

  Update(){
    this.spinner.show();
    let payload = this.additionalDetailsForm.value;
     payload.StuOrgDonate = parseInt(payload.StuOrgDonate);
    payload.StuHostelAccod = parseInt(payload.StuHostelAccod);
    payload.StuFmlyInc = parseInt(payload.StuFmlyInc);
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
    let da = this.additionalDetailsForm.value.StuFromDate;
    payload['StuFromDate'] = this.datepipe.transform(da, 'yyyy-MM-dd');
    let da1 = this.additionalDetailsForm.value.StuToDate;
    payload['StuToDate'] = this.datepipe.transform(da1, 'yyyy-MM-dd');
    this.umsService.updateAdditionalDetails(payload).subscribe(res => {
      if(res.status){
        this.saveWorkExperience();
      this.umsService.setTabSaved('additionalTab');
  const canUpdateScrutiny =
  this.tabs &&
  this.umsService.isRequiredTabsSaved(this.tabs);
  if (canUpdateScrutiny) {
  const confirmData = {};

  confirmData['message'] =
    'Are You Sure You Have Updated ' +
    this.tabs +
    ' Tabs. Do You Want To Proceed?';

  confirmData['title'] = 'Alert';
  confirmData['icon'] = 'fa fa-question';

  this.dialogRef =
    this.modalPopupService.openPopup<ConformationModelComponent>(
      ConformationModelComponent,
      confirmData
    );
  this.dialogRef.afterClosed().subscribe(result => {
    if (result === 'yes') {
      this.UpdScrtDetails();
        if (this.tabs?.includes('Wrong Payment')) {
      this.router.navigate(['/Fees']);
      }
    }
  });
}
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.next.emit();
      }else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  back() {
    if(this.contactDetails.StuNationality === 'OS'){
      console.log('this.contactDetails',this.contactDetails)
     this.prev.emit(true);
    }
    else{
   this.prev.emit(false);
    }
   
  }

  todate(event: any) {
    let dateeee = this.additionalDetailsForm.value.StuToDate;
    let toDate = this.datepipe.transform(dateeee, 'yyyy-MM-dd');
    if (this.additionalDetailsForm.value.StuFromDate == '' || this.datepipe.transform(this.additionalDetailsForm.value.StuFromDate, 'yyyy-MM-dd') == '') {
      let data = {}
      data['message'] = "Select Valid From Date"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.additionalDetailsForm.controls['StuToDate'].setValue('');
    }
    else if (this.additionalDetailsForm.value.StuFromDate >= toDate || this.datepipe.transform(this.additionalDetailsForm.value.StuFromDate, 'yyyy-MM-dd') >= toDate) {
      let data = {}
      data['message'] = "Valid Till Date should Not Less Than From Date"
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.additionalDetailsForm.controls['StuToDate'].setValue('');

    }
  }

  fetchEmpType() {
    this.calledApi++; // Increment the called API count
    const payload = {};
    payload['CdType'] = 'ET';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++; // Increment the finished API count
       if (this.finishedApi === this.calledApi) {
         this.spinner.hide();
       }
        this.EmpTypeCodeList = res.data;
        this.filteredListEmpTypeCode = this.EmpTypeCodeList.slice();
      } else {
        this.finishedApi++; // Increment the finished API count
       if (this.finishedApi === this.calledApi) {
         this.spinner.hide();
       }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++; // Increment the finished API count
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  AdharContact(value){
    if(value == 2){
      this.AdharPhone = true;
    if (this.contactDetails.StuNationality === 'OS') {
      this.additionalDetailsForm.controls['StuAadharPhone'].clearValidators();
      this.additionalDetailsForm.controls['StuAadharPhone'].updateValueAndValidity();
    }
    else{
      this.additionalDetailsForm.controls['StuAadharPhone'].setValidators(Validators.required);
      this.additionalDetailsForm.controls['StuAadharPhone'].updateValueAndValidity();
    }
      this.AbcId = false
      this.additionalDetailsForm.controls['StuABCId2'].setValue('');
      this.additionalDetailsForm.controls['StuABCId2'].clearValidators();
      this.additionalDetailsForm.controls['StuABCId2'].updateValueAndValidity();
    }
    else if(value == 1){
      this.AbcId = true;
      if(this.StuNationality) {
        this.additionalDetailsForm.controls['StuABCId2'].setValue('');
        this.additionalDetailsForm.controls['StuABCId2'].clearValidators();
      }
      else { this.additionalDetailsForm.controls['StuABCId2'].setValidators(Validators.required); }
      this.additionalDetailsForm.controls['StuABCId2'].updateValueAndValidity();
      this.AdharPhone = false;
      this.additionalDetailsForm.controls['StuAadharPhone'].setValue('');
      this.additionalDetailsForm.controls['StuAadharPhone'].clearValidators();
      this.additionalDetailsForm.controls['StuAadharPhone'].updateValueAndValidity();
    }
    this.additionalDetailsForm.markAllAsTouched();
  }

  Aadhar(value){ 
    if(value == 1){
      this.AadharCard = true
      // this.additionalDetailsForm.controls['StuAadhaarNo'].markAsTouched();
      // this.additionalDetailsForm.controls['StuAadhaarNo'].setValidators(Validators.required);
      // this.additionalDetailsForm.controls['StuAadhaarNo'].updateValueAndValidity();
      this.additionalDetailsForm.controls['StuAadhaarNo'].markAsUntouched();
      this.additionalDetailsForm.controls['StuAadhaarNo'].setErrors(null);
      this.additionalDetailsForm.controls['StuAadhaarNo'].clearValidators();
      this.additionalDetailsForm.controls['StuAadhaarNo'].setValue('');
    }
    else if(value == 2){
      this.AadharCard = false
      this.additionalDetailsForm.controls['StuAadhaarNo'].markAsUntouched();
      this.additionalDetailsForm.controls['StuAadhaarNo'].setErrors(null);
      this.additionalDetailsForm.controls['StuAadhaarNo'].clearValidators();
      this.additionalDetailsForm.controls['StuAadhaarNo'].setValue('');
    }
  }

  getDistrictData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
      if(res.status){
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.districtList = res.data;
        this.filteredListdistrictCode = this.districtList.slice();
      }
      else{
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        this.districtList = []
      }
    
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
          if (this.finishedApi === this.calledApi) {
            this.spinner.hide();
          }
    });
  }

  getCollegeData(dsCode) {
    this.collegedataList =[];
    this.filteredListCollege=[]
    this.spinner.show();
    const payload = {};
    payload['DsCode'] = dsCode
    this.umsService.DistrictWiseCollege(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        this.collegedataList = res.data;
        this.filteredListCollege = this.collegedataList.slice();
   
      }
      else{
        this.spinner.hide();
      }
       
    },(ERROR: HttpErrorResponse) => {
      this.collegedataList = [];
      this.spinner.hide();
    })
  }

  fetchMedium() {
    this.calledApi++; // Increment the called API count
    const payload = {};
    payload['CdType'] = 'ME';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.finishedApi++;
          if (this.finishedApi === this.calledApi) {
            this.spinner.hide();
          }
        this.MediumCodeList = res.data;
        this.filteredListMediumCode = this.MediumCodeList.slice();
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }


  pursuingOtherCourse(value){
    if(value == 2){
     this.otherCourse=false
    }
    else if(value == 1){
      this.otherCourse=true
    }
    
  }


   fetchContact() {
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchContactDetails(payload).subscribe(res => {
    console.log('res.data',res.data[0])
    this.contactDetails = res.data[0]
    if (res.data[0].StuNationality === 'OS') {
      this.umsService.studentProgressList['StudentReservation'] = 1;
      this.StuNationality = res.data[0].StuNationality;
    }
    }, (ERROR: HttpErrorResponse) => {     
    })
  }
  reassignValidator(){
    if (this.contactDetails.StuNationality === 'OS') {
      this.additionalDetailsForm.controls['StuPassPort'].setValidators(Validators.required);
      this.additionalDetailsForm.controls['StuPassPort'].updateValueAndValidity();
      // this.additionalDetailsForm.controls['StuAadharPhone'].clearValidators();
      // this.additionalDetailsForm.controls['StuAadharPhone'].updateValueAndValidity();
    }
    else{
      // this.additionalDetailsForm.controls['StuAadharPhone'].setValidators(Validators.required);
      // this.additionalDetailsForm.controls['StuAadharPhone'].updateValueAndValidity();
      this.additionalDetailsForm.controls['StuPassPort'].clearValidators();
      this.additionalDetailsForm.controls['StuPassPort'].updateValueAndValidity();
    }
  }
  saveWorkExperience() {
  const payload = {
    StuId: this.StudentPersonalId,
    StuTopic: null,
    StuGuideName: null,
    WorkExperience: this.additionalDetailsForm.value.WorkExperience
  };

  this.umsService.StudentOtherDetails(payload).subscribe(res => {
    if (res.status) {
      this.additionalDetailsForm.get('WorkExperience')?.setValue(payload.WorkExperience);
      console.log('Work Experience Saved Successfully');
    }
  }, (ERROR: HttpErrorResponse) => {
    console.log(ERROR);
  });

}
  }